import { parseResourceName, ResourceName } from '@sharefile/domino-resource-name-utils';
import { AxiosResponse } from 'axios';

export function getResolvedResourceName(fqn: string): ResourceName {
	let resourceName = parseResourceName(fqn);
	if (typeof resourceName !== 'object') {
		resourceName = {
			namespace: 'ShareFile',
			package: 'sharefile',
			name: fqn,
			version: undefined as any,
		};
	}

	return resourceName;
}

export async function apiProxy<T>(
	proxyFn: (headers: any) => Promise<AxiosResponse<T>>,
	_proxyLabel: string
): Promise<T> {
	const response = await proxyFn({
		'X-BFF-CSRF': 'true',
	});

	if (response.status < 200 || response.status > 399) {
		throw new Error(JSON.stringify(response));
	}

	return response.data;
}
